import {
  Message,
  RealTimeService,
} from "./../../service/websockets/realtime.service";
import { UntypedFormControl } from "@angular/forms";
import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Event, Router } from "@angular/router";
import moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from "src/app/common/utils";
import { AllPatient } from "src/app/models/patient";
import { VproService } from "src/app/service/vpro/vpro.service";
import Swal from "sweetalert2";
import { environment } from "src/environments/environment";
import { NgbDateStruct, NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ChatMessages } from "src/app/models/chat-model";
import { Physician } from "src/app/models/physician";
import { SocketsConnectionService } from "src/app/service/websockets/connection.service";
import { VedioHomeComponent } from "../vedio-components/home/home.component";
import { TypingStatus } from "src/app/models/typing-status";
import { Subscription } from "rxjs";
import { sortBy } from 'underscore';
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
@Component({
  selector: "app-doctor-consultation",
  templateUrl: "./doctor-consultation.component.html",
  styleUrls: ["./doctor-consultation.component.css"],
})
export class DoctorConsultationComponent implements OnInit {
  @ViewChild("PDFModal", { static: true } as any) PDFModal: TemplateRef<any>;
  @ViewChild("home") videoComp: VedioHomeComponent;
  @ViewChild("onlineJoinCall", { static: true } as any)
  onlineJoinCall: TemplateRef<any>;
  @ViewChild("chatModalPhy", { static: true } as any)
  chatModalPhy: TemplateRef<any>;
  @ViewChild("joinChatNotification", { static: true } as any)
  joinChatNotification: TemplateRef<any>;

  public role = Utils.ROLE.PHYSICIAN;
  public aptid;
  showOnlineJoinCall: boolean = false;
  public focus: boolean = false;
  isMinimize: boolean = false;
  modalRef: NgbModalRef;
  prescriptionForm: UntypedFormGroup;
  public notificationMessage: string = "";
  public messageAction = Utils.messageAction;
  prescription: UntypedFormArray;
  intakeFreqTypesList = Utils.INTAKE_FREQ_TYPE_LIST;
  intakefreqList: any = [];
  //intakefreq = Utils.INTAKE;
  intakeList = Utils.INTAKE;
  public showChatModal = false;
  currentDate = Utils.maxDate;
  patient: AllPatient;
  dateFormat = Utils.DATE_FORMAT;
  followupStatus = Utils.FOLLOWUP_STATUS;
  chatUserType = Utils.CHAT_USER_TYPE;
  remainingText: any;
  value: string = " ";
  appointment: any;
  isEditable: boolean = true;
  consultationReport: any;
  followup: any;
  prescriptions: any;
  isFollowupRequired: boolean = true;
  displayFollowupSection: boolean;
  isAmountOther: boolean = false;
  appointments: any = [];
  pdfSrc: any;
  attachmentSignedUrl: string;
  Imagekey: string;
  physicianFee: any;
  chatForm: UntypedFormGroup;
  public currentStatus = "";
  messages: ChatMessages[] = [];
  public typingStatus: TypingStatus;
  public chatMessageSub: Subscription;
  public chatJoinSub: Subscription;
  physicianDetail: Physician;
  chatStarted: boolean = false;
  public parameter: any;
  room_id: string = "";
  connection_id: string = "";
  onlineApt: boolean = true;
  audioCall: boolean = false;
  videoCall: boolean = false;
  maxSize = Utils.MAX_FILE_VIDEO_SIZE;
  maxFileSize = Utils.MAX_FILE_SIZE;
  PrescriptionType = Utils.PRESCRIPTIONTYPE;
  editCurrentTab: string = "medicalInformation";
  forms = {
    medicalInformation: null,
    appetiteHabits: null,
  };
  medicine_template: UntypedFormArray;
  panel_expa: boolean = false;
  tmpl_expa: boolean = false;
  cate: any;
  unique: any[];
  newarr: any[];
  prescriptiontmpl: UntypedFormArray;
  tmpl_search_form: UntypedFormGroup;
  prescriptiontmplForm: UntypedFormGroup;
  patient_appHabbitsList: any = [];
  currentPrescriptionList: any[] = [];
  previousPrescriptionList: any[] = [];
  pid: any;
  cid: any;
  drid: string;
  momentDate: any;
  pdf_url = null;
  editCurrentTabs: string[] = ["personalInformation", "medicalInformation"];
  diseaseList: any = [];
  showReason: boolean = false;
  public workingHours = [];
  excludeDays: number[];

  constructor(
    private utils: Utils,
    private modal: NgbModal,
    private service: VproService,
    private spinner: NgxSpinnerService,
    private _formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private realTimeService: RealTimeService,
    private fb: UntypedFormBuilder,
  ) {
    this.momentDate = moment().format("YYYY-MM-DD");
  }
  templateForm() {


    this.tmpl_search_form = this._formBuilder.group({
      tmpl_name_org: [''],
    })


    this.prescriptiontmplForm = this._formBuilder.group({
      sdate: [null, Validators.required],
      edate: [null, Validators.required],
      pre_template_details: this._formBuilder.array([]),
    });
    this.forms.appetiteHabits = this.fb.group({
      medicine_template: this._formBuilder.array([]),
    });
  }

  ngOnInit() {
    this.spinner.show();
    this.prescriptionForm = this._formBuilder.group({
      summary: ["", Validators.required],
      prescriptionItems: this._formBuilder.array([]),
      completed: ["", Validators.required],
      remarks: [""],
      followupRequired: [""],
      fee: [""],
      followup_fee: [""],
      followupFeePatient: [""],
      followupFeeOther: [""],
      followupDate: [""],
    });
    this.chatForm = this._formBuilder.group({
      chat_msg: [""],
    });
    this.getPhysicianDetails();
    this.addpPrescription();

    this.chatJoinSub = this.service.chatMessageSubject.subscribe((value) => {
      let values: ChatMessages = { ...value };
      if (values.type === Utils.NOTIFICATION_TYPES.JOIN_CHAT) {
        this.notificationMessage = values.message;
        if (this.modalRef) {
          this.modalRef.close();
        }
        this.modalRef = this.modal.open(this.joinChatNotification, {
          size: "lg",
          centered: true,
          backdrop: "static",
        });
      }
    });

    this.prescriptionForm.get("completed").valueChanges.subscribe((val) => {
      if (val == "no") {
        this.prescriptionForm.get("remarks").setErrors({ required: true });
        this.prescriptionForm.get("followupDate").setValue(""); // New changes
        this.prescriptionForm.get("followupRequired").setValue("");


      } else {
        this.prescriptionForm.get("remarks").setValue("");
        this.prescriptionForm.get("remarks").setErrors(null);
        this.prescriptionForm.get("followupRequired").setErrors({ required: true });
        // this.prescriptionForm.get("followupRequired").setValue("no");


        // New Changes Start
        if (this.appointment.apdate) {
          let fdate = moment(this.appointment.apdate).format("DD/MM/YYYY");
          var contractMoment = moment(fdate, "DD/MM/YYYY");
        }

        if (this.appointment.physician_details.physician_consultfee[0].followup_days) {
          let start = moment(contractMoment).add(
            this.appointment.physician_details.physician_consultfee[0].followup_days, "days"
          );
          // let startDate = start['_i'].split('/');
          // this.prescriptionForm.patchValue({
          //   followupDate: { year: parseInt(startDate[2]), month: parseInt(startDate[1]), day: parseInt(startDate[0]) }
          // })
          let startDate = new Date(start['_d']);

          let mnth = ("0" + (startDate.getMonth() + 1)).slice(-2);
          let days = ("0" + startDate.getDate()).slice(-2);
          let yer = startDate.getFullYear();

          this.prescriptionForm.patchValue({
            followupDate: { year: yer, month: parseInt(mnth), day: parseInt(days) }
          })
        } else {
          let start = moment(contractMoment).add(Utils.DEFAULT_DAYS, "days");
          //console.log("start 2", start)
          let startDate = start['_i'].split('/');
          this.prescriptionForm.patchValue({
            followupDate: { year: parseInt(startDate[2]), month: parseInt(startDate[1]), day: parseInt(startDate[0]) }
          })
          // this.prescriptionForm.get("followupDate").setValue(start.toDate());
        }
      }
      this.prescriptionForm.updateValueAndValidity();
    });

    this.prescriptionForm.get("followupRequired").valueChanges.subscribe((val) => {
      if (val == "no") {

        this.prescriptionForm.get("followupDate").setValue("");
      } else {

        if (this.appointment.apdate) {
          let fdate = moment(this.appointment.apdate).format("DD/MM/YYYY");
          var contractMoment = moment(fdate, "DD/MM/YYYY");
        }

        if (
          this.appointment.physician_details.physician_consultfee[0].followup_days
        ) {
          let start = moment(contractMoment).add(
            this.appointment.physician_details.physician_consultfee[0]
              .followup_days,
            "days"
          );
          // let startDate = start['_i'].split('/');
          // this.prescriptionForm.patchValue({
          //   followupDate: { year: parseInt(startDate[2]), month: parseInt(startDate[1]), day: parseInt(startDate[0]) }
          // })
          let startDate = new Date(start['_d']);

          let mnth = ("0" + (startDate.getMonth() + 1)).slice(-2);
          let days = ("0" + startDate.getDate()).slice(-2);
          let yer = startDate.getFullYear();

          this.prescriptionForm.patchValue({
            followupDate: { year: yer, month: parseInt(mnth), day: parseInt(days) }
          })
        } else {
          let start = moment(contractMoment).add(Utils.DEFAULT_DAYS, "days");
          // console.log("start 2", start)
          let startDate = start['_i'].split('/');
          this.prescriptionForm.patchValue({
            followupDate: { year: parseInt(startDate[2]), month: parseInt(startDate[1]), day: parseInt(startDate[0]) }
          })
          // this.prescriptionForm.get("followupDate").setValue(start.toDate());
        }
        // New changes end
      }
      this.prescriptionForm.updateValueAndValidity();
    });

    this.getPatient();
    this.getAppointment();
    this.chatForm
      .get("chat_msg")
      .valueChanges.debounceTime(2000)
      .subscribe((value) => {
        let data = { u_id: this.pid };
        data["id"] = this.drid;
        data["action"] = this.messageAction.SENDMESSAGE;
        data["room_id"] = this.room_id;
        data["message"] = "";
        data["type"] = Utils.NOTIFICATION_TYPES.TYPING_STATUS;
        this.currentStatus = "";
        this.realTimeService.send(data);
      });


    this.getDiseaseList();
    this.getAppHabbitList();

    this.tmpl_search_form = this._formBuilder.group({
      tmpl_name_org: [''],
    })
    this.forms.appetiteHabits = this.fb.group({
      medicine_template: this.fb.array([]),
    });
    this.prescriptiontmplForm = this._formBuilder.group({
      sdate: [null, Validators.required],
      edate: [null, Validators.required],
      pre_template_details: this._formBuilder.array([]),


    });
    this.pid = this.route.snapshot.queryParams["pid"];
    this.cid = this.route.snapshot.queryParams["aid"];
    // console.log("his.pid", this.pid)
    // console.log("his.cid", this.cid)

    this.drid = localStorage.getItem("uid");
    this.fetchPreviousPrescriptions();
    this.spinner.hide();

    this.getDefaultWorkingHours(this.drid)
  }

  addpPrescription() {
    this.prescription = this.prescriptionForm.get(
      "prescriptionItems"
    ) as UntypedFormArray;
    this.prescription.push(this.createpPrescription());
    this.intakefreqList.push([]);
  }

  createpPrescription(): UntypedFormGroup {
    return this._formBuilder.group({
      mname: [""],
      strength: [""],
      intake: [""],
      intakefreq: [""],
      intakefreq_type: [""],
      sdate: [],
      edate: [],
      remarks: [""],
    });
  }

  public removingCurrentPrescription(i: number): void {
    this.prescription.removeAt(i);
  }

  track(item: any, index: number) {
    return index;
  }

  freqTypeSelected(event, i) {
    this.intakeFreqTypesList.forEach((type) => {
      // console.log("type", type.value);
      // console.log("event", event.target.value);
      if (type.value == event.target.value)
        this.intakefreqList[i] = type.freq_options;
    });
    this.prescription.at(i).get("intakefreq").reset();
    if (event.target.value === "Whenever Required") {
      this.prescription
        .at(i)
        .get("intakefreq")
        .setValue(this.intakeFreqTypesList[2].freq_options[0]);
      this.prescription.at(i).get("intakefreq").updateValueAndValidity();
    }
  }

  getPatient() {
    this.spinner.show();
    this.service
      .getPatientById(this.route.snapshot.queryParams["pid"])
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.patient = res;
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
  getAppointment() {
    this.spinner.show();
    this.aptid = this.route.snapshot.queryParams["aptid"];
    // console.log("aptid", this.aptid)
    if (this.aptid) {
      this.room_id = this.aptid;
    }
    this.service
      .getAppointmentDetails({
        aptid: this.aptid,
        fields: [
          "physician_details",
          "followup_details",
          "documents",
          "conference_link_phy",
        ],
      })
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.appointment = res;
          this.updateRoomId();
          if (this.appointment.apttype) {
            if (
              this.appointment.apttype === Utils.APPOINTMENT_TYPE.AUDIO ||
              this.appointment.apttype === Utils.APPOINTMENT_TYPE.VIDEO
            ) {
              this.onlineApt = true;
            }
            if (this.appointment.apttype === Utils.APPOINTMENT_TYPE.AUDIO) {
              this.audioCall = true;
              this.videoCall = false;
            } else if (
              this.appointment.apttype === Utils.APPOINTMENT_TYPE.VIDEO
            ) {
              this.audioCall = false;
              this.videoCall = true;
            }
          }
          this.patchValueforSummary();
          this.patchValueforConsultFee();
          if (
            this.appointment &&
            this.appointment.followup_details &&
            this.appointment.followup_details.length > 0
          )
            this.appointments = this.appointment.followup_details;

          if (
            this.appointment &&
            this.appointment.documents &&
            this.appointment.documents.length > 0
          ) {
            this.appointment.documents.forEach((element, index) => {
              if (
                element.key &&
                element.key.length > 0 &&
                element.key.includes("/")
              ) {
                let file = element.key.split("/");
                if (file && file.length > 0)
                  this.appointment.documents[index]["name"] = file.pop();
              }
            });
          }
          if (this.appointment.consultation_completed) {
            this.isEditable = false;
            this.submit();
          }
        },
        (error) => {
          this.spinner.hide();
          this.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }

  getControl(field: string): UntypedFormControl {
    if (field == "patient_medication" || field == "medicine_template" || field == "patient_appetite" || field == "patient_med_history" || field == "patient_lifestyle" || field == "patient_fmed_history" || field == "pat_stats") {
      return this.forms[this.editCurrentTabs[1]].get(field) as UntypedFormControl;
    }
    else {

      return this.prescriptionForm.get(field) as UntypedFormControl;
    }

  }

  getControlLabel(type: number) {
    return this.prescriptionForm.controls[type].value;
  }

  patchValueforConsultFee() {
    if (
      this.appointment &&
      this.appointment.physician_details &&
      this.appointment.physician_details.physician_consultfee
    ) {
      this.prescriptionForm.patchValue({
        followup_fee:
          this.appointment.physician_details.physician_consultfee[0]
            .followup_fee,
        followupFeePatient: 0,
      });
      if (this.appointment.apdate) {
        let fdate = moment(this.appointment.apdate).format("DD/MM/YYYY");
        var contractMoment = moment(fdate, "DD/MM/YYYY");
      }
      if (
        this.appointment.physician_details.physician_consultfee[0].followup_days
      ) {
        let start = moment(contractMoment).add(
          this.appointment.physician_details.physician_consultfee[0]
            .followup_days,
          "days"
        );
        // let startDate = start['_i'].split('/');
        // this.prescriptionForm.patchValue({
        //   followupDate: { year: parseInt(startDate[2]), month: parseInt(startDate[1]), day: parseInt(startDate[0]) }
        // })
        let startDate = new Date(start['_d']);

        let mnth = ("0" + (startDate.getMonth() + 1)).slice(-2);
        let days = ("0" + startDate.getDate()).slice(-2);
        let yer = startDate.getFullYear();

        this.prescriptionForm.patchValue({
          followupDate: { year: yer, month: parseInt(mnth), day: parseInt(days) }
        })
      } else {
        let start = moment(contractMoment).add(Utils.DEFAULT_DAYS, "days");
        console.log("start 2", start)
        let startDate = start['_i'].split('/');
        this.prescriptionForm.patchValue({
          followupDate: { year: parseInt(startDate[2]), month: parseInt(startDate[1]), day: parseInt(startDate[0]) }
        })
        // this.prescriptionForm.get("followupDate").setValue(start.toDate());
      }
    }
  }

  patchValueforSummary() {
    if (this.appointment && this.appointment.consultation_summary) {
      this.prescriptionForm.patchValue({
        summary: this.appointment.consultation_summary,
      });
    }
  }

  submit() {
    this.spinner.show();
    let data = {
      aptid: this.appointment.aptid,
      passcode: this.appointment.passcode,
    };
    if (localStorage.getItem("uid"))
      data["uid"] = JSON.parse(localStorage.getItem("uid"));

    this.service.getPrescription(data).subscribe(
      (res) => {
        this.spinner.hide();
        this.consultationReport = res;
        if (res && res.prescription) {
          this.prescriptions = res.prescription[0].json_agg;
        }
      },
      (error) => {
        this.spinner.hide();
        let msg =
          error && error.error && error.error.message
            ? error.error.message
            : "Something went wrong. Please try again.";
        this.showToast("error", msg);
      }
    );
  }

  sendPrescription() {
    let data = {
      consultation: {
        summary: this.prescriptionForm.value.summary,
        completed:
          this.prescriptionForm.value.completed == "yes" ? true : false,
      },
      aid: this.route.snapshot.queryParams["aid"],
      followup: {},
    };

    if (this.isFollowupRequired && this.displayFollowupSection) {
      let date = this.prescriptionForm.get("followupDate").value
      let y = date.year;
      let m = date.month;
      let d = date.day;
      let appDate = `${y}-${m}-${d}`;
      console.log("appDate", appDate);
      (data["followup"]["fee"] = this.physicianFee),

        (data["followup"]["apdate"] = appDate);
    } else {
      delete data["followup"];
    }
    if (this.prescriptionForm.value.remarks) {
      data["consultation"]["remarks"] = this.prescriptionForm.value.remarks;
    }
    data["prescription"] = [];
    let flag = false;

    let prescriptionItems = this.prescriptionForm.value.prescriptionItems.map(
      (x, i) => {
        this.setFormValidators(i);
        if (this.prescription.at(i).status == "VALID") {
          if (x.mname !== "" || x.strength !== "") {
            x.sdate = x.sdate.year + "-" + x.sdate.month + "-" + x.sdate.day;
            x.edate = x.edate.year + "-" + x.edate.month + "-" + x.edate.day;
            if (!x.remarks) delete x.remarks;
            x = {
              ...x,
              pid: this.route.snapshot.queryParams["pid"],
              drid: this.route.snapshot.queryParams["drid"],
            };
            data["prescription"].push({ ...x });
          }
        } else {
          this.showToast("error", "Please fill the required fields.");
          flag = true;
        }
      }
    );

    if (!data["prescription"].length) {
      delete data["prescription"];
    }
    if (!flag && this.prescriptionForm.valid) {
      Swal.fire({
        title: "Complete Consulation",
        text: "Are you sure?",
        type: "info",
        showCancelButton: true,
        buttonsStyling: true,
        confirmButtonClass: "btn btn-primary",
        confirmButtonText: "Yes",
        cancelButtonClass: "btn btn-secondary",
      }).then((result) => {
        if (result.value) {
          console.log("data", data)
          this.spinner.show();
          this.service
            .addPrescription(data, this.route.snapshot.queryParams["pid"])
            .subscribe(
              (res) => {
                this.spinner.hide();
                this.showToast("success", res.message);
                setTimeout(() => {
                  this.gotoPage();
                }, 2000);
                setTimeout(() => {
                  window.location.reload();
                }, 3000);
              },
              (error) => {
                console.log(error);
                this.spinner.hide();
                let message;
                if (
                  error &&
                  error.error &&
                  error.error.message &&
                  error.error.message.message
                ) {
                  message = error.error.message.message;
                } else if (error && error.error && error.error.message) {
                  message = error.error.message;
                } else message = "Something went wrong. Please try again.";
                this.showToast("error", message);
              }
            );
        }
      });
    }
  }

  setFormValidators(i = 0) {
    if (
      this.prescription.at(i).get("mname").value !== "" ||
      this.prescription.at(i).get("strength").value !== "" ||
      this.prescription.at(i).get("intake").value !== "" ||
      this.prescription.at(i).get("intakefreq").value !== "" ||
      this.prescription.at(i).get("intakefreq_type").value !== ""
    ) {
      this.prescription.at(i).get("mname").setValidators(Validators.required);
      this.prescription
        .at(i)
        .get("strength")
        .setValidators(Validators.required);
      this.prescription
        .at(i)
        .get("intake")
        .setValidators([Validators.required]);
      this.prescription
        .at(i)
        .get("intakefreq")
        .setValidators([Validators.required]);
      this.prescription
        .at(i)
        .get("intakefreq_type")
        .setValidators([Validators.required]);
      if (!this.prescription.at(i).get("sdate").value)
        this.prescription.at(i).get("sdate").setErrors({ required: true });
      if (!this.prescription.at(i).get("edate").value)
        this.prescription.at(i).get("edate").setErrors({ required: true });
    } else {
      this.prescription.at(i).get("mname").clearValidators();
      this.prescription.at(i).get("strength").clearValidators();
      this.prescription.at(i).get("intake").clearValidators();
      this.prescription.at(i).get("intakefreq").clearValidators();
      this.prescription.at(i).get("intakefreq_type").clearValidators();
    }
    this.prescription.at(i).get("mname").updateValueAndValidity();
    this.prescription.at(i).get("strength").updateValueAndValidity();
    this.prescription.at(i).get("intake").updateValueAndValidity();
    this.prescription.at(i).get("intakefreq").updateValueAndValidity();
    this.prescription.at(i).get("intakefreq_type").updateValueAndValidity();
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title,
    });
  }

  gotoPage() {
    this.router.navigate(["/appointment/consultation"]);
  }

  displayFollowup(v) {
    if (v == this.followupStatus.YES) this.displayFollowupSection = true;
    else this.displayFollowupSection = false;
    console.log("Consultation Completed", this.displayFollowupSection)
  }

  followupRequired(event) {
    if (event) {
      this.isFollowupRequired = JSON.parse(event?.target?.value);
      //console.log("this.isFollowupRequired ", this.isFollowupRequired);
    }
  }

  followupFee(e) {
    if (e == "noFee") {
      this.isAmountOther = false;
      this.prescriptionForm.get("followupFeePatient").setValue(0);
    } else if (e == "defaultFee") {
      this.isAmountOther = false;
      let defaultFeeAndExtraCharges: any = Math.ceil(
        this.appointment.physician_details.physician_consultfee[0]
          .followup_fee +
        (1 - this.appointment.physician_details.consultation_share) *
        parseFloat(
          this.appointment.physician_details.physician_consultfee[0]
            .followup_fee
        )
      ); //13
      let defaultFee: any = parseFloat(
        this.appointment.physician_details.physician_consultfee[0].followup_fee
      ); //10
      this.physicianFee = defaultFee;
      this.prescriptionForm
        .get("followupFeePatient")
        .setValue(defaultFeeAndExtraCharges);
    } else {
      this.isAmountOther = true;
    }
  }

  otherFee() {
    this.isAmountOther = true;
    let otherFees: any =
      parseFloat(this.prescriptionForm.get("followupFeeOther").value) +
      (1 - this.appointment.physician_details.consultation_share) *
      parseFloat(this.prescriptionForm.get("followupFeeOther").value);
    otherFees = Math.ceil(otherFees);
    let defaultFee: any = parseFloat(
      this.prescriptionForm.get("followupFeeOther").value
    );
    this.physicianFee = defaultFee;
    this.prescriptionForm.get("followupFeePatient").setValue(otherFees);
  }

  previewDocument(doc: any) {
    if (doc && doc.key && doc.key.length > 0) {
      let uri = environment.content_base_url + "/" + doc.key;
      if (Utils.allowedImageFormats.includes(doc.key.split(".").pop())) {
        Swal.fire({
          imageUrl: uri,
          showConfirmButton: false,
          showCloseButton: true,
        });
      } else {
        this.pdfSrc = uri;
        this.modal.open(this.PDFModal, {
          size: "lg",
          centered: true,
          backdrop: "static",
        });
      }
    }
  }

  downloadDocument(doc) {
    if (doc && doc.signedUrl) {
      Utils.downloadFileWithSignedUrl(doc);
    } else {
      Utils.downloadFile(doc);
    }
  }

  closeModal() {
    this.modal.dismissAll();
  }

  closeVideoScreen() {
    let video: any = document.querySelector("#preview > video");
    if (video && video.srcObject) {
      for (const track of video.srcObject.getTracks()) {
        track.stop();
      }
      video.srcObject = null;
    }
    this.showOnlineJoinCall = false;
    this.isMinimize = false;
  }

  public minimize() {
    this.isMinimize = true;
  }

  public maximize() {
    this.isMinimize = false;
  }

  subscribeToChatMessage() {
    this.service.consultNowUpdate.subscribe((data: any) => {
      this.sendJoinChatNotification();
      // this.messages.push({ id: 1118, body: "how are you?", date: moment().toDate() });
      // this.messages.push({ id: 1118, body: "how can I help you?", date: moment().toDate() });
      // //this.messages.push({ id: data.uid, body: data.message, date: moment().toDate() });
    });
  }

  sendJoinChatNotification() {
    let data = { u_id: this.appointment.pid };
    data["id"] = this.appointment.drid;
    data["action"] = this.messageAction.SENDMESSAGE;
    data["room_id"] = this.room_id;
    data["message"] = "Physician has Joined the ChatRoom";
    data["type"] = Utils.NOTIFICATION_TYPES.JOIN_CHAT;
    this.realTimeService.send(data);
  }
  sendStatusTyping(event) {
    //keycode of enter is 13
    if (event.keyCode !== 13 && this.currentStatus !== "Typing") {
      this.currentStatus = "Typing";
      //send to websocet
      this.sendStatus();
    }
  }

  sendStatus() {
    let data = { u_id: this.appointment.pid };
    data["id"] = this.appointment.drid;
    data["action"] = this.messageAction.SENDMESSAGE;
    data["room_id"] = this.room_id;
    data["message"] = this.currentStatus;
    data["type"] = Utils.NOTIFICATION_TYPES.TYPING_STATUS;
    this.realTimeService.send(data);
  }

  sendMessage() {
    this.currentStatus = "";
    //u_id is the id to which we are sending messages
    let data = { u_id: this.patient.pid };
    //id is the id from which we are sending messages
    data["id"] = this.appointment.drid;
    data["action"] = this.messageAction.SENDMESSAGE;
    data["room_id"] = this.room_id;
    data["type"] = Utils.CHAT_ACTION.NEW_MESSAGE;
    data["aptid"] = this.appointment.aptid;
    data["contentType"] = "text";
    data["msg_time"] = moment().utc().format(Utils.DB_TIMESTAMP_FORMAT);
    data["from"] = this.chatUserType.PHYSICIAN;

    if (this.chatForm.get("chat_msg").value) {
      data["message"] = this.chatForm.get("chat_msg").value;
      this.realTimeService.send(data);
    }
    if (this.chatForm.get("chat_msg").value) {
      this.messages.push({
        id: JSON.parse(localStorage.getItem("uid")),
        u_id: this.patient.pid,
        body: this.chatForm.get("chat_msg").value,
        date: moment().toDate(),
      });
      setTimeout(() => {
        this.chatForm.patchValue({ chat_msg: "" });
        this.chatForm.get("chat_msg").updateValueAndValidity();
      }, 100);
    }
  }

  async selectFile(event) {
    let data = { u_id: this.patient.pid };
    data["id"] = this.appointment.drid;
    data["action"] = this.messageAction.SENDMESSAGE;
    data["room_id"] = this.room_id;
    data["type"] = Utils.CHAT_ACTION.SEND_ATTACHMENT;
    data["aptid"] = this.appointment.aptid;
    data["msg_time"] = moment().utc().format(Utils.DB_TIMESTAMP_FORMAT);
    data["from"] = this.chatUserType.PHYSICIAN;
    let {
      target: { files },
    } = event;
    let [file] = files;
    let reader = new FileReader();
    if (file) {
      let previewUrl;
      if (file.size > this.maxFileSize) {
        this.showToast("error", "File exceeds 2MB");
        event.srcElement.value = null;
        return;
      }
      reader.readAsDataURL(file);
      data["name"] = file.name;
      reader.onload = (event: any) => {
        previewUrl = event.target.result;
        // this.messages[this.messages.length - 1].body["previewUrl"] = previewUrl.toString();
        this.messages.push({
          id: this.appointment.drid,
          u_id: this.appointment.pid,
          body: { contentType: file.type, previewUrl, name: file.name },
          date: moment().toDate(),
        });
      };
      //get signed url and upload on S3
      await this.service
        .uploadFile(
          {
            room_id: this.room_id,
            aptid: this.appointment.aptid,
            file: { name: file.name, type: file.type },
          },
          file
        )
        .subscribe(
          (res) => {
            this.attachmentSignedUrl = res.signedUrl;
            this.Imagekey = res.key;
            data["contentType"] = file.type;
            data["message"] = this.Imagekey;
            this.realTimeService.send(data);
            this.spinner.hide();
          },
          (error) => {
            this.spinner.hide();
            this.showToast("error", "Something went wrong.Please try again !");
          }
        );
    }
  }

  previewImg(i) {
    console.log(this.messages[i]);

    if (
      Utils.IMGFILE ==
      this.messages[i].body["contentType"].substring(
        0,
        this.messages[i].body["contentType"].indexOf("/")
      )
    ) {
      Swal.fire({
        imageUrl: this.messages[i].body["previewUrl"],
        showConfirmButton: false,
        showCloseButton: true,
      });
    } else {
      this.pdfSrc = this.messages[i].body["previewUrl"];
      this.modal.open(this.PDFModal, {
        size: "lg",
        centered: true,
        backdrop: "static",
      });
    }
  }

  updateRoomId() {
    let data = { room_id: this.room_id };
    this.service.fetchRoomIDPhy(data).subscribe((res) => {
      this.room_id = res.room_id;
      this.subscribeToChatMessage();
    });
    this.showChatModal = false;
  }

  notifyCall(type) {
    // console.log("type", type)
    if (this.showOnlineJoinCall) {
      this.isMinimize = false;
      return;
    }
    this.showOnlineJoinCall = true;
    let data = { u_id: this.patient.pid };
    data["id"] = this.appointment.drid;
    data["action"] = this.messageAction.SENDMESSAGE;
    data["room_id"] = this.room_id;
    data["type"] = Utils.NOTIFICATION_TYPES.ENABLE_ONLINE_CALL;
    if (type === Utils.APPOINTMENT_TYPE.AUDIO) {
      data["message"] = Utils.ENABLE_CALL.AUDIO;
    } else {
      data["message"] = Utils.ENABLE_CALL.VIDEO;
    }
    this.realTimeService.send(data);
    //console.log("data", data)
  }

  checkMsgType(body) {
    if (body) {
      if (typeof body === "string") {
        return typeof body;
      } else {
        return body["contentType"].substring(
          0,
          body["contentType"].indexOf("/")
        );
      }
    }
  }

  getPhysicianDetails() {
    this.service.getPhysicianById(localStorage.getItem("uid")).subscribe(
      (result) => {
        this.physicianDetail = result;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  async startChat() {
    this.chatStarted = true;
    this.chatMessageSub = this.service.chatMessageSubject.subscribe((value) => {
      const values: ChatMessages = { ...value };
      if (values.type === Utils.CHAT_ACTION.NEW_MESSAGE) {
        this.messages.push({
          id: values.id,
          body: values.message,
          date: moment().toDate(),
        });
      } else if (values.type === Utils.CHAT_ACTION.SEND_ATTACHMENT) {
        this.messages.push({
          id: values.id,
          body: {
            previewUrl: values.message.toString(),
            contentType: values.contentType,
            name: values.name,
          },
          date: moment().toDate(),
        });
      } else if (values.type === Utils.NOTIFICATION_TYPES.TYPING_STATUS) {
        this.typingStatus = { status: values.message };
      } else if (values && values.type === Utils.messageAction.GETMESSAGES) {
        values.data.forEach((value) => {
          if (value.contentType == "text") {
            this.messages.push({
              id: value.id,
              body: value.body,
              date: value.msg_time,
            });
          } else {
            this.messages.push({
              id: value.id,
              body: {
                previewUrl: value.body.toString(),
                contentType: value.contentType,
                name: value.name,
              },
              date: value.date,
            });
          }
        });
      }
    });
    this.getChatHistory();
  }

  getChatHistory() {
    let data = {};
    data["u_id"] = this.appointment.drid;
    data["aptid"] = this.appointment.aptid;
    data["room_id"] = this.room_id;
    data["action"] = this.messageAction.SENDMESSAGE;
    data["type"] = this.messageAction.GETMESSAGES;
    this.realTimeService.send(data);
  }

  enterSubmit(event) {
    if (event.keyCode == 13 && !event.shiftKey) {
      //Stops enter from creating a new line
      event.preventDefault();
      return true;
    }
  }

  closePopUp() {
    this.modalRef.close();
  }
  ngOnDestroy() {
    this.chatForm.reset();
    if (this.chatMessageSub) {
      this.chatMessageSub.unsubscribe();
    }
    if (this.chatJoinSub) {
      this.chatJoinSub.unsubscribe();
    }
  }

  addAppetites(id): UntypedFormGroup {
    return this.fb.group({
      tmpl_id: [id],
      sdate: [null, Validators.required],
      edate: [null, Validators.required],
    });
  }

  createMedicine(sdate, edate): UntypedFormGroup {
    return this._formBuilder.group({
      sdate: [null, Validators.required],
      edate: [null, Validators.required],
    });
  }

  addNewFormArray(arrayName) {
    //console.log("arrayName", arrayName)
    this[arrayName] = this.forms[this.editCurrentTab].get([
      arrayName,
    ]) as UntypedFormArray;


    if (arrayName === "medicine_template") {
      this[arrayName].push(this.createMedicine(null, null));

    }

  }
  formValidation(i, key, arrayName) {
    let error = false;
    if (
      this.forms["medicalInformation"].get([arrayName]).controls[i] &&
      this.forms["medicalInformation"].get([arrayName]).controls[i].controls[
      key
      ] &&
      this.forms["medicalInformation"].get([arrayName]).controls[i].controls[
        key
      ].errors
    ) {
      error = true;
    }
    return error;
  }
  // SEARCH TEMPLATE from search button click
  searchtmpl() {
    this.tmpl_expa = true;

    let data = { ...this.tmpl_search_form.value };
    // console.log(
    //   "this.forms.appetiteHabits s1", this.forms.appetiteHabits.value.medicine_template
    // )
    this.templateForm();
    delete this.forms.appetiteHabits.value.medicine_template
    data.org_code = localStorage.getItem("orgcode");
    data.drid = parseInt(localStorage.getItem("uid"));

    if (data.tmpl_name == "") {
      delete data.tmpl_name;
    }
    // console.log(data);

    this.spinner.show();
    this.service
      .sarchpresTempl(data)
      .subscribe(
        (res) => {
          // window.location.reload();
          this.spinner.hide();
          // console.log(
          //  "this.forms.appetiteHabits s2", this.forms.appetiteHabits.value.medicine_template
          //  )
          this.cate = res;
          this.unique = [...new Map(this.cate.map((m) => [m.tmpl_id, m])).values()];
          for (let apetite of res) {
            this.medicine_template = this.forms.appetiteHabits.get(
              "medicine_template"
            ) as UntypedFormArray;
            this.medicine_template.push(this.addAppetites(apetite.tmpl_id));
          }
        },
        (error) => {
          console.log(error);
        }
      );

  }



  public getMedicineNameLabels(i) {
    return this.cate[i].mname;
  }

  public getMedicineintakeLabels(i) {
    return this.cate[i].intake;
  }
  public getMedicineintakefreqLabels(i) {
    return this.cate[i].intakefreq;
  }
  public getMedicineintakefreq_typeLabels(i) {
    return this.cate[i].intakefreq_type;
  }
  public getMedicinestrengthLabels(i) {
    return this.cate[i].strength;
  }

  fetchPreviousPrescriptions() {
    this.previousPrescriptionList = [];
    this.currentPrescriptionList = [];
    this.service
      .fetchPatientPrescriptionsByPhysician({ pid: this.pid, drid: this.drid })
      .subscribe((result) => {
        //console.log(result);
        if (result && result.length > 0) {
          result.forEach((record) => {
            if (record['cid'] == this.route.snapshot.queryParams["aid"]) {
              this.currentPrescriptionList.push(record);
              // console.log("this.currentPrescriptionList1", this.currentPrescriptionList)
            } else {
              this.previousPrescriptionList.push(record);
              this.previousPrescriptionList = sortBy(this.previousPrescriptionList, 'sdate').reverse(); // Data Sorter via underscore.js
            }
          });
        }
      });
  }
  deletePrescription(prescriptions) {
    // console.log("prescriptions", prescriptions)
    // console.log("prescriptions_id", prescriptions.prid)
    let prescriptions_id = prescriptions.prid
    this.service.deletePrescri(prescriptions_id).subscribe(
      (data) => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 2500,
        });

        Toast.fire({
          type: "success",
          title: "prescriptions has been deleted successfuly",
        });
        // console.log('Record deleted', data);
        this.fetchPreviousPrescriptions()
        // this.prescriptionForm.reset();
      })
  }
  // fetchPreviousPrescriptionsTemplates() {
  //   this.previousPrescriptionList = [];
  //   this.currentPrescriptionList = [];
  //   this.service
  //     .fetchPatientPrescriptionsByPhysician({ pid: this.pid, drid: this.drid })
  //     .subscribe((result) => {
  //       console.log(result);
  //       if (result && result.length > 0) {
  //         result.forEach((record) => {

  //           if (moment(record.edate).format("YYYY-MM-DD") >= this.momentDate) {
  //             this.currentPrescriptionList = result;
  //             console.log("this.currentPrescriptionList1", this.currentPrescriptionList)
  //           } else {
  //             this.previousPrescriptionList = result;
  //           }
  //         });
  //       }
  //     });
  // }

  public showFormArrayVal(index, arrayName, key) {
    let val, val2;
    val = this[arrayName].value[index][key];
    if (arrayName === "patient_med_history" && key === "disease_id") {
      this.diseaseList.forEach((element) => {
        if (element.id == val) {
          val = element.disease_name;
        }
      });
    }

    if (arrayName === "medicine_template" && key === "tmpl_id") {
      if (this.patient_appHabbitsList[val - 1]) {
        val = this.patient_appHabbitsList[val - 1].mname;
      }

    }



    return val;
  }


  submitPrescriptionTemplate(temp_id) {
    this.panel_expa = false;
    this.tmpl_expa = false;
    let data = {
      consultation: {
        completed: null,
      },
      ...this.forms.appetiteHabits.value,
      aid: this.route.snapshot.queryParams["aid"],
    };
    data["prescription"] = [];
    let prescriptionItems = data.medicine_template.map(
      (x, i) => {
        if (x.sdate !== null || x.edate !== null) {
          x.sdate = x.sdate.year + "-" + x.sdate.month + "-" + x.sdate.day;
          x.edate = x.edate.year + "-" + x.edate.month + "-" + x.edate.day;
          x.mname = this.cate[i].mname;
          x.intake = this.cate[i].intake;
          x.intakefreq = this.cate[i].intakefreq;
          x.intakefreq_type = this.cate[i].intakefreq_type;
          x.strength = this.cate[i].strength;
          delete x.tmpl_id;
          x = {
            ...x,
            pid: this.route.snapshot.queryParams["pid"],
            drid: this.route.snapshot.queryParams["drid"],
          };
          data["prescription"].push({ ...x });
          this.showToast("success", "Prescription added successfully");
        }
      }
    );
    delete data.medicine_template;
    if (data["prescription"].length === 0 && data["consultation"].completed === null) {
      this.showToast("error", "Please Add Prescription Date");
      return null;

    }







    this.service
      .addPrescription(data, this.route.snapshot.queryParams["pid"])
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.removeuntypeformReset()
          this.fetchPreviousPrescriptions();
        },
        (error) => {
          // console.log(error);
          this.spinner.hide();
          let message;
          if (
            error &&
            error.error &&
            error.error.message &&
            error.error.message.message
          ) {
            message = error.error.message.message;
          } else if (error && error.error && error.error.message) {
            message = error.error.message;
          } else message = "Something went wrong. Please try again.";
          this.showToast("error", message);
        }
      );
  }


  getAppHabbitList() {
    this.service.getAppHabbitList().subscribe((res) => {
      this.patient_appHabbitsList = res;
    });
  }
  printPage(eve) {

    let data = {
      aid: parseInt(this.cid),
    }

    //console.log('this.currentPrescriptionList', this.currentPrescriptionList);
    if (eve.target.id === this.PrescriptionType.CURRENTPRESCRIPTION) {
      data['prescription'] = this.currentPrescriptionList;
      this.service.CurrentPrescriptionPdf(data, `?type=offine_prescription`).subscribe((result) => {
        if (result) {

          this.pdf_url = environment.content_base_url + "/" + result;
          window.open(this.pdf_url);
        }
      });
    }
    if (eve.target.id === this.PrescriptionType.PREVIOUSPRESCRIPTION) {
      data['prescription'] = this.previousPrescriptionList;
      this.service.CurrentPrescriptionPdf(data, `?type=offine_prescription&past_medication=true`,).subscribe((result) => {
        if (result) {
          this.pdf_url = environment.content_base_url + "/" + result;
          window.open(this.pdf_url);
        }
      });

    }
    this.pdf_url = "";
  }

  getDiseaseList() {
    this.service.getDiseaseList().subscribe((res) => {
      this.diseaseList = res;
    });
  }
  removeuntypeformReset(): void {
    this.forms.appetiteHabits.reset();
    this.tmpl_search_form.reset();
  }
  getDayName = {
    '0': 'Sun',
    '1': 'Mon',
    '2': 'Tue',
    '3': 'Wed',
    '4': 'Thu',
    '5': 'Fri',
    '6': 'Sat'
  }
  getDefaultWorkingHours(dr_id) {
    let drid = dr_id;
    this.spinner.show();
    this.service.getWorkingHours(drid).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res && res.length > 0) {
          this.workingHours = res;
          this.excludeDays = [];
          this.workingHours.map(x => {
            x.dayName = this.getDayName[x.day];
            x.start_time = x.start_time.split(':');
            x.start_time = { hour: parseInt(x.start_time[0]), minute: parseInt(x.start_time[1]) };
            x.end_time = x.end_time.split(':');
            x.end_time = { hour: parseInt(x.end_time[0]), minute: parseInt(x.end_time[1]) };
            if (x.start_time.hour === x.end_time.hour && x.start_time.minute === x.end_time.minute) {
              x.Checked = true;
            } else {
              x.Checked = false;
            }
          });
        }
        this.excludeDays = this.workingHours.filter(day => day.Checked).map(day => day.day);

        console.log("getWorkingHours", this.workingHours);
        console.log("excludeDays", this.excludeDays);


      },
      err => {
        this.spinner.hide();
        console.log(err);
      });
  }
  disableWeekends = (date: NgbDateStruct) => {
    const day = new Date(date.year, date.month - 1, date.day).getDay();
    return this.excludeDays.includes(day);
  }
}
